import { useParams, useNavigate } from "react-router-dom";
import { useConnectStore } from "../../store/Connect";
import { useVendorJobStore } from "../../store/VendorJobs";
import { VendorJobRequestInterface } from "@/dentconnect/src/pages/job-request/VendorJobRequestInterface";
import { Loading } from "@/components/src/animations/loading";

interface VendorJobRequestPageProps {
	organizationId: string;
	organizationName: string;
	onSuccess?: () => void;
}

export const VendorJobRequestPage: React.FC<VendorJobRequestPageProps> = ({
	organizationId,
	organizationName,
	onSuccess,
}) => {
	const { vendorId } = useParams<{ vendorId: string }>();
	const navigate = useNavigate();
	const brandsByOrgId = useConnectStore((state) => state.brandsByOrgId);
	const connectedVendors = useConnectStore((state) => state.connectedVendors);

	if (!organizationId || !organizationName) {
		return <Loading />;
	}

	if (!vendorId) {
		return (
			<div className="p-4">
				<p className="text-gray-500">Lieferant nicht gefunden</p>
			</div>
		);
	}

	const isVendorConnected = connectedVendors.includes(vendorId);

	if (!isVendorConnected) {
		return (
			<div className="p-4">
				<p className="text-gray-500">Lieferant nicht verbunden</p>
			</div>
		);
	}

	const vendorName = brandsByOrgId[vendorId]?.name ?? "Unbekannt";

	const handleSuccess = () => {
		useVendorJobStore.getState().fetchVendorData(vendorId, organizationId);
		if (onSuccess) {
			onSuccess();
		} else {
			navigate(`/vendor/${vendorId}`);
		}
	};

	return (
		<div className="h-full overflow-y-auto">
			<VendorJobRequestInterface
				vendorId={vendorId}
				vendorName={vendorName}
				myOrgId={organizationId}
				myOrgName={organizationName}
				onSuccess={handleSuccess}
			/>
		</div>
	);
};
